import {
  BookOpen,
  Bot,
  ContactRound,
  CreditCard,
  FileText,
  Home,
  List,
  RefreshCw,
  Scale,
  SquarePower,
  WalletCards,
} from 'lucide-react'

import { CommandProps } from '~/components/command-menu/types'
import { sendTrackingData } from '~/utils/tracking'

export const navigationCommands: CommandProps[] = [
  {
    category: 'navigation',
    label: () => 'Go to an account...',
    icon: () => <List />,
    // no callback needed because switching accounts is the default behavior
    onSelect: ({ actions: { setActiveView } }) => {
      sendTrackingData('command_menu_item_selected', {
        category: 'navigation',
        item: 'go_to_account',
      })

      setActiveView('select_account')
    },
    shortcuts: ['g > a'],
  },
  {
    category: 'navigation',
    label: () => 'Switch workspace...',
    icon: () => <SquarePower />,
    // no callback needed because switching teams is the default behavior
    onSelect: ({ actions: { setActiveView } }) => {
      sendTrackingData('command_menu_item_selected', {
        category: 'navigation',
        item: 'switch_team',
      })

      setActiveView('select_team')
    },
    shortcuts: ['g > w'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Dashboard',
    icon: () => <Home />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_dashboard',
      })

      navigate('/')

      setActiveView(null)
    },
    isDisabled: ({ pathname }) => pathname === '/',
    shortcuts: ['g > d'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Accounts',
    icon: () => <WalletCards />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_accounts',
      })

      navigate('/accounts')

      setActiveView(null)
    },
    shortcuts: ['g > o'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Cards',
    icon: () => <CreditCard />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_cards',
      })

      navigate('/accounts?tab=cards')

      setActiveView(null)
    },
    shortcuts: ['g > r'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Automations',
    icon: () => <Bot />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_automations',
      })

      navigate('/accounts?tab=automation')

      setActiveView(null)
    },
    shortcuts: ['g > u'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Contacts',
    icon: () => <ContactRound />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_contacts',
      })

      navigate('/contacts')

      setActiveView(null)
    },
    isDisabled: ({ pathname }) => pathname === '/contacts/',
    shortcuts: ['g > c'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Compliance',
    icon: () => <Scale />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_compliance',
      })

      navigate('/compliance')

      setActiveView(null)
    },
    isDisabled: ({ pathname }) => pathname === '/compliance/',
    shortcuts: ['g > p'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Schedules',
    icon: () => <RefreshCw />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_schedules',
      })

      navigate('/schedules')

      setActiveView(null)
    },
    isDisabled: ({ pathname }) => pathname === '/schedules/',
    shortcuts: ['g > s'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Invoices',
    icon: () => <FileText />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_invoices',
      })

      navigate('/invoices')

      setActiveView(null)
    },
    isDisabled: ({ pathname }) => pathname === '/invoices/',
    shortcuts: ['g > i'],
  },
  {
    category: 'navigation',
    label: () => 'Go to Accounting',
    icon: () => <BookOpen />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'navigation',
        item: 'go_to_accounting',
      })

      navigate('/accounting')

      setActiveView(null)
    },
    isDisabled: ({ pathname }) => pathname === '/accounting/',
    shortcuts: ['g > x'],
  },
]
